/* eslint-disable prettier/prettier */
import { useState, useEffect } from 'react';
import * as React from 'react';
import { ISelectListItem, IPurchasedService } from '../../Common/types';
import axios from "axios";
import { Tariff } from "../../Models/Tariff/Tariff";
import PayTariff from "./PayTariff";
import { TariffPlan } from "../../enums/TariffPlan";
import UploadFilePopup from "../../Popups/UploadFilePopup";
import Tooltip from "../../Ui/Tooltip";
import Base64ToFile from '../../Utils/Base64ToFile';
import Loading from "../../Ui/Loading";
import moment from "moment-timezone";

interface IPropsType {

}



function TariffsList() {
    const [allTariffs, setAllTariffs] = useState<Tariff[] | []>([]);
    const [activeTariff, setActiveTariff] = useState<any>();
    const [isPay, setIsPay] = useState(false);
    const [selectedPlanId, setSelectedPlanId] = useState<TariffPlan | null>(null);
    const [showType, setShowType] = useState(null);

    const [isLoading, setIsLoading] = useState(false);

    const getActiveTariff = async () => {
        try {
            const res = await axios.get("/api/TariffApi/GetMyTariff");
            setActiveTariff(res.data);
            console.log(res);
        } catch (err) {
            console.log(err);
        }
    }

    const getAllTariffs = async () => {
        try {
            const res = await axios.get("/api/TariffApi/GetAllTariffs");
            console.log("Все тарифы", res);
            setAllTariffs(res.data);
            setShowType(res.data[0]?.Name);
        } catch (err) {
            console.log(err);
        }
    }

    useEffect(() => { console.log(showType) }, [showType])

    useEffect(() => {
        getActiveTariff();
        getAllTariffs();
    }, [])

    const uploadPayment = async (file, planId) => {
        setIsLoading(true);
        console.log(file);
        const formData = new FormData();
        formData.append("file", file?.[0] || file);
        formData.append("planId", planId.toString());

        try {
            const res = await axios.post("/api/TariffApi/UploadTariffCheck", formData)

            setActiveTariff(prev => ({ ...prev, PendingTariffPlanId: planId }));
            setIsLoading(false);
            console.log(res);
        } catch (err) {
            console.log(err);
            setIsLoading(false);
        }
    }

    return (
        <>
            <h4 className="purpleTextHead">Тарифный план</h4>
            {isLoading && <Loading />}
            <div className="typeFilter">
                {allTariffs.length > 1 && allTariffs.map(item => (
                    <span
                        onClick={() => setShowType(item.Name)}
                        className={`${showType === item.Name && "active"}`}
                    >{item.Name}</span>
                ))}
            </div>
            <div className="tariffs">
                {activeTariff && allTariffs.length && showType &&
                    <>
                        {allTariffs.map(item2 => (
                            <>
                                {item2.List.map((item: Tariff) => (

                                    showType === item2.Name &&
                                    <div className={`tariffCard ${item.TariffPlan === activeTariff.TariffPlan && "active"}`}>
                                        {item.TariffPlan === activeTariff.TariffPlan &&
                                            <div className="activeTariff"><span>Текущий</span></div>
                                        }
                                        <div className="tariffTitle">
                                            <h4>{item.Name}</h4>
                                            <div className="tariffPrice">
                                                <span>{item.Price}</span>
                                                <p>₽/мес</p>
                                            </div>
                                        </div>

                                        <hr className="stroke"></hr>

                                        <div className="tariffDescription">
                                            <div className="item">
                                                <h4>{item.RewardPercent}</h4>
                                                <p>вознаграждение при успешных торгах VIOMITRA выплачивает продавцу из своей комиссии</p>
                                            </div>
                                            <div className="item">
                                                <h4>{item.LotFeePercent}</h4>
                                                <p>от цены лота оплачивает победитель торгов при успешной сделке</p>
                                            </div>
                                            <div className="item">
                                                <h4>
                                                    {item.TariffPlan == activeTariff.TariffPlan ? (
                                                        <>
                                                            {activeTariff.RemainingLotPlacements + "/" + item.LotPlacementCount}
                                                        </>
                                                    ) : (
                                                        item.LotPlacementCount
                                                    )}
                                                </h4>
                                                <p>лотов для размещения</p>
                                            </div>
                                            <div className="item">
                                                <h4>{item.LotPlacementCost} ₽</h4>
                                                <p>стоимость одного размещения</p>
                                            </div>
                                            {item.BonusCurrencyAmount &&
                                                <div className="item">
                                                    <h4>{item.BonusCurrencyAmount} MI</h4>
                                                    <p>на оплату услуг продвижения</p>
                                                </div>
                                            }
                                            {item.HasClosedAccess &&
                                                <div className="item">
                                                    <h4 className="buisiness">Доступ к закрытым продажам и инвестиционному бутику</h4>
                                                </div>
                                            }
                                        </div>
                                        {item.TariffPlan !== activeTariff.TariffPlan && item.TariffPlan > activeTariff.TariffPlan &&
                                            <div className="actions">
                                                {activeTariff.PendingTariffPlanId === item.TariffPlan ? (
                                                    <p className="pendingPayment">Документ об оплате загружен и ожидает подтверждения Администратора</p>
                                                ) : activeTariff.PreviousTariffPlanId === item.TariffPlan ? (
                                                    <>
                                                        <span
                                                            className="defaultPinkButton"
                                                            onClick={() => { setIsPay(true); setSelectedPlanId(item.TariffPlan) }}
                                                        >Продлить</span>

                                                        <UploadFilePopup
                                                            head={{ title: "Загрузите чек об оплате" }}
                                                            getFile={(file) => { uploadPayment(file, item.TariffPlan) }}
                                                        >
                                                            <Tooltip
                                                                side="left"
                                                                text="Загрузите чек об оплате"
                                                            >
                                                                <button><img src="/main-images/fileIcon.svg" /></button>
                                                            </Tooltip>
                                                        </UploadFilePopup>
                                                    </>
                                                ) : (
                                                    <>
                                                        <span
                                                            className="defaultPinkButton"
                                                            onClick={() => { setIsPay(true); setSelectedPlanId(item.TariffPlan) }}
                                                        >Заказать</span>

                                                        <UploadFilePopup
                                                            head={{ title: "Загрузите чек об оплате" }}
                                                            getFile={(file) => { uploadPayment(file, item.TariffPlan) }}
                                                        >
                                                            <Tooltip
                                                                side="left"
                                                                text="Загрузите чек об оплате"
                                                            >
                                                                <button><img src="/main-images/fileIcon.svg" /></button>
                                                            </Tooltip>
                                                        </UploadFilePopup>
                                                    </>
                                                )}
                                            </div>
                                    }

                                        {item.TariffPlan === activeTariff.TariffPlan &&
                                            <p
                                                style={{
                                                    color: "white",
                                                    fontFamily: "Montserrat",
                                                    fontSize: "14px"
                                                }}
                                            >Оплачен до {moment(activeTariff.DateEnd).format("DD.MM.YYYY")}</p>
                                        }
                                    </div>
                                ))}
                            </>
                        ))}
                    </>
                }
            </div>

            <PayTariff
                isOpen={isPay}
                close={() => { setIsPay(false) }}
                planId={selectedPlanId}
            />
        </>
    )
}

export default TariffsList;


